import * as React from 'react';

import BaseSaleHistoryLayout from "~/apps/pos/mobile/pages/BaseSaleHistoryLayout";


export default function() {
  return (
    BaseSaleHistoryLayout()
  );
};
